// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\n    margin: 0;\n    padding: 0;\n}\n/* Hide the Google reCAPTCHA badge */\n.grecaptcha-badge {\n    visibility: hidden !important;\n}\n", ""]);
// Exports
module.exports = exports;
